module.exports = __webpack_public_path__ + "04_medium_gold.70127033.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_medium_gold.png
// module id = JFjF
// module chunks = 0